<div style="display: flex; justify-content: center; align-self: center;">
    <p>validating...</p>
</div>
